// Simple loop to require all image assets used by backend rails app
function importAll(r) {
  r.keys().forEach(r);
}
// useSubdirectories=true to include all images subdirectories
importAll(require.context('images/', true, /\.(svg|png|jpg)$/));
